import React from 'react';
import { Routes, Route } from 'react-router-dom';
/* import ResponsiveAppBar from './views/NavBar';
import ResponsiveFootBar from './views/FootBar'; */
import { Box } from '@mui/material';
import PrivacyPolicy from './views/PrivacyPolicy.js';
import TermsAndConditions from './views/TermsAndConditions.js';
import MarketMonitorHealth from './views/MarketMonitorHealth/marketMonitorHealth.js';
import MarketOrganization from './views/MarketMonitorHealth/marketOrganization.js';
import MarketComparativeHealth from './views/MarketMonitorHealth/marketComparativeHealth.js';

const App = () => {

  return (
    <>
      {/* <ResponsiveAppBar /> */}
      <Box sx={{ minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />

          {/* Market Monitor Health */}
          <Route path="/" element={<MarketMonitorHealth />} />
          <Route path="/market-monitor-health" element={<MarketMonitorHealth />} />
          {/* slug unico */}
          <Route path="/market-organization/:countrySlug/:organizationSlug" element={<MarketOrganization />} />
          <Route path="/market-organization/:organizationSlug" element={<MarketOrganization />} />
          {/* slug unico */}
          <Route path="/market-organization" element={<MarketOrganization />} />
          <Route path="/market-comparative-health" element={<MarketComparativeHealth />}
          />
        </Routes>
      </Box>
      {/* <ResponsiveFootBar /> */}
    </>
  );
};

export default App;
